import { useMemo } from "react";

import { isNil } from "lodash-es";
import { Box, Select, SelectChangeEvent, Skeleton } from "@parspec/pixel";

import { useActiveUsers } from "./hooks/useActiveUsers";
import { RESET_SELECT_OPTION } from "./constant";

interface SelectOutsideSalesProps {
    value: string | number;
    onChange: (e: SelectChangeEvent<string | number>) => void;
    name?: string;
    showResetOption?: boolean;
};

export default function SelectOutsideSales(props: SelectOutsideSalesProps) {
    const { name, value, showResetOption = false, onChange } = props;
    const { data, isLoading } = useActiveUsers();

    const outsideSalesOptions = useMemo(() => {
        if (!data?.data) return [];

        const options = data.data.map((activeUser) => ({
            value: activeUser.user_details.id,
            label: activeUser.user_details.name,
        }));

        return showResetOption ? [RESET_SELECT_OPTION, ...options] : options;
    }, [data?.data, showResetOption]);

    if (isLoading) {
        return (
            <Box padding={2} height={36} borderRadius={1} border="1px solid" borderColor="neutral.dark">
                <Skeleton variant="rounded" width="100%" height="100%" />
            </Box>
        );
    }

    return (
        <Select
            options={outsideSalesOptions}
            id="outside-sales-select"
            label="Outside Sales"
            labelId="outside-sales-select-label"
            name={name}
            value={isNil(value) ? "" : value}
            onChange={onChange}
        />
    )
}